import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import * as fromActionsProgress from 'store/actions/blockProgress.action'
import { useCourse } from 'contexts'
import {
  getDefaultProgress,
  getInitialContentProgress,
} from './getInitialContentProgress'

interface UseInitialContentProgressProps {
  videoRef: React.RefObject<HTMLVideoElement>
  block: {
    id: number
    blockInstanceableId: number
    courseId: number
  }
}

export const useInitialContentProgress = ({
  videoRef: ref,
  block,
}: UseInitialContentProgressProps) => {
  const { previewMode, enrolled } = useCourse()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchProgress = async () => {
      if (!enrolled || previewMode) return getDefaultProgress()
      return getInitialContentProgress(block)
    }

    fetchProgress()
      .then((data) => {
        dispatch(
          fromActionsProgress.Actions.currentLessonBlockProgressSucess({
            id: block.id,
            blockInstanceableId: block.blockInstanceableId,
            data: data,
          })
        )
        if (ref.current) ref.current.currentTime = data.currentTime
      })
      .finally(() => setLoading(false))
  }, [block, dispatch, enrolled, previewMode, ref])

  return { loading }
}
